import get from 'lodash/get';
import { RootState } from '~/store';
import { IReward } from '~/types';
import preloaded from '~/preloaded';
import { isProd } from '~/index';

const generateImages = (urls: Array<string>) => {
    const images: Array<HTMLImageElement> = [];

    urls.forEach((url) => {
        const img = new Image();
        img.src = url;
        images.push(img);
    });
};

const ignoreIndexes: Array<number> = [];

const rewards: Array<IReward> = get(window.dockyard, 'state.event.rewards', []);
for (let index = 0; index < rewards.length; index++) {
    const reward = rewards[index];
    const isShip = reward.gameRewards.map((r) => r.type).includes('ship');
    if (isShip) {
        ignoreIndexes.push(index);
    }
}

export const preload = (state: RootState) => {
    const urls: Array<string> = [];

    state.app.rewards.forEach((reward, index) => {
        if (!ignoreIndexes.includes(index)) {
            urls.push(reward.image);
        }
    });

    fetch(`${preloaded.urls.static || ''}${isProd ? 'assets/' : ''}assets.json`)
        .then((response) => {
            if (response.status !== 200) {
                generateImages(urls);
                return;
            }
            response.json().then((data: AssetsData) => {
                const backgrounds = data[''] ? data[''].jpg : [];
                backgrounds.forEach((url: string) => {
                    urls.push(`${preloaded.urls.static}${isProd ? 'assets/' : ''}${url}`);
                });
                generateImages(urls);
            });
        })
        .catch(() => {
            generateImages(urls);
        });
};

export const preloadBackgrounds = (state: RootState) => {
    const assetsForPreload: string[] = [
        state.app.educationBackground,
        state.app.congratulationBackground,
        state.app.purchaseConfirmationBackground,
    ];

    if (state.app.shipPreviewBackground) {
        assetsForPreload.push(state.app.shipPreviewBackground);
    }

    if (state.app.secondaryShipPreviewBackground) {
        assetsForPreload.push(state.app.secondaryShipPreviewBackground);
    }

    const urls: string[] = assetsForPreload.filter((url) => !!url);
    if (urls.length) {
        generateImages(urls);
    }
};
